<script setup lang="ts">
import dayjs, { type Dayjs } from 'dayjs'
import PItem from '../../../../list/PItem.vue'
import PList from '../../../../list/PList.vue'
import type { TimeEntry } from '../../types'

type Props = {
  timeEntries: TimeEntry[]
}

type Emits = {
  (e: 'time-selected'): void
}

const emit = defineEmits<Emits>()
defineProps<Props>()
const model = defineModel<Dayjs | null>()

const onSelect = (timeEntry: TimeEntry): void => {
  const [hourStr, minuteStr] = timeEntry.value.split(':')
  const hour = parseInt(hourStr)
  const minute = parseInt(minuteStr)
  model.value = (model.value ?? dayjs()).tz().hour(hour).minute(minute)
  emit('time-selected')
}
</script>

<template>
  <p-list>
    <p-item
      v-for="(timeEntry, n) of timeEntries"
      :key="n"
      :text="timeEntry.text"
      :active="model?.format('HH:mm') === timeEntry.value"
      :focused="model?.format('HH:mm') === timeEntry.value"
      :cy="`time-item-${timeEntry.text}`"
      :data-scroll-into-view="model?.format('HH:mm') === timeEntry.value"
      @click="onSelect(timeEntry)"
    />
  </p-list>
</template>
